<!-- HTML -->
<template>
  <div>

    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-8">
            <figure class="image">
              <img src="../../assets/img/home/industrial-bridge.jpg" alt="Jugem's Cloud standing in front of an industrial bridge">
            </figure>
            <h5>Photograph by Dave Ludwin</h5>
          </div>
          <div class="column is-4">
            <div class="text-box-container">
              <div class="text-box-wrapper">
                <h1 class="title is-1">
                  Chicago
                  <br>
                  Industrial
                  <br>
                  Music
                </h1>
                <h3 class="subtitle is-3">//////</h3>
                <p>Jugem's Cloud is an aggressive electro industrial band, blending modern sounds with a fresh take on classic industrial music. Emerging from the bowels of Chicago's factories and steel refineries, Jugem's Cloud writes with solid songwriting, heavy synth basslines, crushing drums, and pounding samples for an unforgettable and fully industrial combination.</p>
                <h5 class="subtitle is-5">
                  <router-link to="/band" class="underline">
                    Dare to enter the Bloc?
                  </router-link>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<!-- JavaScript -->
<script>

export default {
  name: "HomeAbout"
};

</script>

<!-- CSS -->
<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

h1 {
  font-family: astera;
  color: $white;
}
h3 {
  color: $green-tint-2;
}
h5 {
  font-family: astera;
  color: $white-trans-1;
}
a {
  text-decoration: underline;
  color: $white-trans-1;
}
a:hover {
  color: $white-trans-2;
}
p {
  padding-bottom: 1rem;
  font-family: astera;
}

.section {
  padding: 12rem 0;
  background-color: $black;
}
.text-box-container {
  position: relative;
  height: 100%;
  width: 100%;
}
.text-box-wrapper {
  position: absolute;
  padding-top: 2rem;
  padding-left: 2rem;
  top: 10%;
  left: -50%;
  width: 150%;
  height: 50%;
  border-top: 2px solid $green-tint-2;
  border-left: 2px solid $green-tint-2;
  background-image: -webkit-linear-gradient(135deg, $black, rgba(0,0,0,0.1)); /* Safari 5.1, iOS 5.0-6.1, Chrome 10-25, Android 4.0-4.3 */
  background-image: -moz-linear-gradient(135deg, $black, rgba(0,0,0,0.1)); /* Firefox 3.6 - 15 */
  background-image: -o-linear-gradient(135deg, $black, rgba(0,0,0,0.1)); /* Opera 11.1 - 12 */
  background-image: linear-gradient(to right, $black, rgba(0,0,0,0.1)); /* Opera 15+, Chrome 25+, IE 10+, Firefox 16+, Safari 6.1+, iOS 7+, Android 4.4+ */
  background-image: linear-gradient(135deg, $black, rgba(0,0,0,0.1));
}
@media screen and (max-width: 768px) {
  .text-box-wrapper {
    position: relative;
    left: 0;
    width: 100%;
  }
}
@media all and (min-width: 769px) and (max-width: 896px) {
  .text-box-wrapper {
    height: 87%;
  }
}
@media all and (min-width: 897px) and (max-width: 1024px) {
  .text-box-wrapper {
    height: 65%;
  }
}
@media all and (min-width: 1025px) and (max-width: 1280px) {
  .text-box-wrapper {
    height: 59%;
  }
}

</style>
